import phoneSvg from '../../../kye-field-call/phone.svg'

export function createCallCellRender({ vm }) {
  return function (h, { rowData, column, value }) {
    return h('div', {
      class: 'table2-warp-custom-call-cell',
    },
      [
        h('span', {}, value),
        value ? h('img', {
          class: 'call-icon',
          attrs: {
            src: phoneSvg,
          },
          on: {
            click: (e) => {
              e.stopPropagation()
              vm.callIconClick(rowData, column, value)
            }
          }
        }) : ''
    ])
  }
}




// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/feature/call-cell-render.js